import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AppLayout from '../../components/layout/app-layout/app-layout';
import DeadlinesTab from './DeadlinesTab';
import WelcomeModal from './WelcomeModal';
import appState from '../../state/AppStateContainer';

const storageKey = () => {
  const id = appState.state.token?.id;
  return id ? `todo_welcome_seen_${id}` : null;
};

const PageDeadlinesMessages: FC = () => {
  const [t] = useTranslation('dashboard');
  const [showWelcome, setShowWelcome] = useState(false);

  useEffect(() => {
    const key = storageKey();
    if (key && !localStorage.getItem(key)) {
      setShowWelcome(true);
    }
  }, []);

  const handleDismiss = () => {
    const key = storageKey();
    if (key) localStorage.setItem(key, '1');
    setShowWelcome(false);
  };

  return (
    <AppLayout title={t('deadlinesMessages.pageTitle', 'Att göra')}>
      {showWelcome && <WelcomeModal onDismiss={handleDismiss} />}
      <div style={{ padding: '16px 32px' }}>
        <DeadlinesTab />
      </div>
    </AppLayout>
  );
};

export default PageDeadlinesMessages;
